import React from 'react'
import { NavLink } from 'react-router-dom'

const PageTitle = ({ primary, title }) => {
    return (
        <div className="page-header">
            <div className="container d-flex flex-column align-items-center">
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <div className="container">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <NavLink to={"/"}>Home</NavLink>
                            </li>
                            <li className="breadcrumb-item">
                                <NavLink to={`/MyAccount`}>{primary}</NavLink>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {title}
                            </li>
                        </ol>
                    </div>
                </nav>
                <h1>{title}</h1>
            </div>
        </div>
    )
}

export default PageTitle
